import service from './src/index';

export default {
    install(Vue) {
        Vue.prototype.$scrollfullSceen = service;
    },
    service
}